import { render, staticRenderFns } from "./ResultadosLogsCalcinacaoTableLogs.vue?vue&type=template&id=59d886f8&"
import script from "./ResultadosLogsCalcinacaoTableLogs.vue?vue&type=script&lang=ts&"
export * from "./ResultadosLogsCalcinacaoTableLogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VIcon,VSimpleTable})
